import React from 'react';
import { Menu, MenuItem, Popover } from 'core/components';

interface Props {
  x: number;
  y: number;
  onZoom: () => void;
  onDismiss: () => void;
}

export function ZoomSelectionPopover({ x, y, onZoom, onDismiss }: Props) {
  return (
    <Popover
      isOpen
      usePortal
      onClose={onDismiss}
      minimal
      placement="right-start"
      modifiers={{
        preventOverflow: { enabled: true },
        flip: { enabled: true }
      }}
      targetProps={{
        style: {
          position: 'absolute',
          top: `${y}px`,
          left: `${x}px`,
          width: '5px',
          height: '5px',
          pointerEvents: 'none'
        }
      }}
      content={
        <Menu>
          <MenuItem icon="zoom-in" text="Zoom to Selection" onClick={onZoom} />
        </Menu>
      }
    >
      <div />
    </Popover>
  );
}
